import StarIcon from '@mui/icons-material/Star'
import StarBorderIcon from '@mui/icons-material/StarBorder'
import { Box, IconButton } from '@mui/material'

interface Props {
  value: number
  onRate?: (v: number) => void
  size?: number
  interactive?: boolean
}

export default function Stars({ value, onRate, size = 20, interactive = false }: Props) {
  return (
    <Box sx={{ display: 'flex', gap: 0 }}>
      {[1, 2, 3, 4, 5].map((i) =>
        interactive ? (
          <IconButton key={i} size="small" onClick={() => onRate?.(i)} sx={{ p: 0.25 }}>
            {i <= value ? (
              <StarIcon sx={{ fontSize: size, color: '#f59e0b' }} />
            ) : (
              <StarBorderIcon sx={{ fontSize: size, color: '#d1d5db' }} />
            )}
          </IconButton>
        ) : (
          <Box key={i} component="span" sx={{ display: 'inline-flex' }}>
            {i <= value ? (
              <StarIcon sx={{ fontSize: size, color: '#f59e0b' }} />
            ) : (
              <StarBorderIcon sx={{ fontSize: size, color: '#d1d5db' }} />
            )}
          </Box>
        ),
      )}
    </Box>
  )
}
